import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface OutageNotice {
  enabled: boolean
  message: string
}

export interface ConfigResponse {
  /** Wrks SSO portal (legacy launch / "back to Wrks"), chosen by the backend from APP_SOURCE. */
  loginUrl: string
  /** Wrks OAuth 2.0 login available: the login button goes to oauthStartUrl and the app auto-starts it once. */
  oauthLoginEnabled?: boolean
  /** `/api/auth/oauth/start` rewritten to the API base by transformApiUrls. */
  oauthStartUrl?: string
  freepassEnabled: boolean
  isStaging: boolean
  /** false on the gov (NCloud) deployment, which has no staging counterpart → hide the staging switch */
  stagingAvailable: boolean
  /** gov deployment mirrors wrks as the single source of truth → content/settings are read-only */
  contentReadOnly: boolean
  outageNotice: OutageNotice
}

export function useConfig() {
  return useQuery<ConfigResponse>({
    queryKey: ['config'],
    queryFn: () => api.get<ConfigResponse>('/config'),
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  })
}

/** True when this deployment's admin must treat shared content/settings as read-only. */
export function useContentReadOnly(): boolean {
  return useConfig().data?.contentReadOnly ?? false
}
